// extracted by mini-css-extract-plugin
module.exports = {"btn":"ConfigEditer_btn_1Wz8s","forminput":"ConfigEditer_forminput_3uBSi","numberinput":"ConfigEditer_numberinput_JIver"};